import React, { Component } from 'react';
import { withStyles } from "@material-ui/core/styles";
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Tooltip from '@material-ui/core/Tooltip';
import { getGrupos } from '../../services/lockers/lockers';


const styles = theme => ({
    iconView: {
        color: "white !important",
    },
    dropdownGroup: {
        margin: "1.5rem 0rem 0rem -7rem",
        zIndex: "10"
    }
});

class DropdownGroup extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleCloseOutside = this.handleCloseOutside.bind(this);
        this.getGroups = this.getGroups.bind(this);
        this.state = {
            selected: 'Todos',
            options: ['Todos'],
            open: false,
            anchorEl: null,
            ITEM_HEIGHT: 48
        }
    }

    componentDidMount() {
        this.getGroups();
        document.addEventListener('mousedown', this.handleCloseOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleCloseOutside);
    }

    getGroups() {
        getGrupos((data) => {
            let optionsAr = [...data];
            let { options } = this.state;

            optionsAr.forEach(o => {
                if (!options.includes(o))
                    options.push(o);
            })

            this.setState({ options });
        });
    }

    handleCloseOutside() {
        this.setState({ anchorEl: null, open: false });
    }

    handleClick(event) {
        this.setState({ anchorEl: event.currentTarget, open: true });
    };

    handleClose(event) {
        this.handleCloseOutside();
        if (event) {
            this.setState({ selected: event });
            this.props.setSelected(event);
        }
    };

    render() {
        const { classes } = this.props;
        return (
            <div className={classes.dropdownGroup}>
                <Tooltip title="Os seguintes relatórios podem ser visualizados por grupo de terminais">
                    <IconButton
                        aria-label="more"
                        aria-controls="long-menu-1"
                        aria-haspopup="true"
                        onClick={this.handleClick}
                    >
                        <MoreVertIcon className={classes.iconView} />
                    </IconButton>
                </Tooltip>
                <Menu
                    id="long-menu-1"
                    anchorEl={this.state.anchorEl}
                    keepMounted
                    open={this.state.open}
                    PaperProps={{
                        style: {
                            maxHeight: this.state.ITEM_HEIGHT * 5.5,
                            width: 100,
                        },
                    }}
                >
                    {this.state.options.map(option => (
                        <MenuItem key={option} selected={option === this.state.selected} onClick={() => this.handleClose(option)}>
                            {option}
                        </MenuItem>
                    ))}
                </Menu>
            </div>
        );
    }
}
export default withStyles(styles)(DropdownGroup);